/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private _keepAfterRouteChange = false;

    private _subject = new Subject<any>();

    constructor(private _router: Router) {
        // üzenet törlése, ha változik az útvonal és a 'keepAfterRouteChange' flag true
        this._router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (this._keepAfterRouteChange) {
                    // első útvonalváltozáskor tartja csak meg
                    this._keepAfterRouteChange = false;
                } else {
                    this.clear();
                }
            }
        });
    }

    /**
     * Üzenet törlése
     */
    clear(): void {
        this._subject.next({});
    }

    /**
     * Lekezelendő új hibaüzenet itt adható meg.
     * @param message Hibaüzenet
     * @param keepAfterRouteChange Első útvonalváltás után tartsa-e meg az üzenetet
     */
    error(message: string, keepAfterRouteChange = false): void {
        this._keepAfterRouteChange = keepAfterRouteChange;
        this._subject.next({ type: 'error', text: message });
    }

    /**
     * Visszaadja az üzenetekre való feliratkozáshoz használható objektumot.
     */
    getAlert(): Observable<any> {
        return this._subject.asObservable();
    }

    /**
     * Lekezelendő új információs üzenet itt adható meg.
     * @param message
     * @param keepAfterRouteChange
     */
    information(message: string, keepAfterRouteChange = false): void {
        this._keepAfterRouteChange = keepAfterRouteChange;
        this._subject.next({ type: 'information', text: message });
    }

    /**
     * Lekezelendő új üzenet itt adható meg.
     * @param message
     * @param keepAfterRouteChange
     */
    success(message: string, keepAfterRouteChange = false): void {
        this._keepAfterRouteChange = keepAfterRouteChange;
        this._subject.next({ type: 'success', text: message });
    }

    /**
     * Lekezelendő új figyelmeztető üzenet itt adható meg.
     * @param message
     * @param keepAfterRouteChange
     */
    warning(message: string, keepAfterRouteChange = false): void {
        this._keepAfterRouteChange = keepAfterRouteChange;
        this._subject.next({ type: 'warning', text: message });
    }
}
